<script>
    import moment from 'moment'
    import DashboardItem from './DashboardItem.svelte'

    export let masters
    export let startWork
    export let endWork
    export let worksheets = []
    export let onClick

    const startWorkDate = moment(startWork)
    const endWorkDate = moment(endWork)

    function generateWorkHours(startWorkDate, endWorkDate) {
        let i = moment(startWorkDate)
        const result = []
        while (i < endWorkDate) {
            const v = moment(i)
            result.push(v)
            i = i.add(1, 'hours')
        }
        return result
    }

    const rowHeight = 24
    const colWidth = 196

    const columnCount = masters.length
    const rowCount = Math.floor((endWorkDate - startWorkDate) / (1000 * 60 * 15))

    const firstColumnWidth = 64
    const firstRowHeight = 64

    const margin = 2

    let container
    let scrollY = 0
    let scrollX = 0

    function master2column(id) {
        for (const i in masters) {
            if (masters[i].id === id) {
                return i
            }
        }
        return -1
    }

    let mousePointerX, mousePointerY

    function mouseMove(e) {
        if (!e.target.classList.contains('selected-item')) {
            mousePointerX = e.offsetX
            mousePointerY = e.offsetY
        }
        containerScroll()
    }
    function containerScroll() {
        scrollX = container.scrollLeft > 0 ? container.scrollLeft : 0
        scrollY = container.scrollTop > 0 ? container.scrollTop : 0
    }

    function containerClick(e) {
        let x = e.offsetX
        let y = e.offsetY
        if (e.target.classList.contains('selected-item')) {
            x += e.target.offsetLeft
            y += e.target.offsetTop
        }

        if (onClick && x > firstColumnWidth && y > firstRowHeight) {
            const box = Math.floor((x - firstColumnWidth) / colWidth)
            if (box > masters.length) {
                return
            }
            const time = startWorkDate + Math.floor((y - firstRowHeight) / rowHeight) * 1000 * 60 * 15
            if (time > endWorkDate) {
                return
            }
            onClick(masters[box].id, moment(time))
        }
    }
</script>
<div bind:this={container}
     class="box vh-100"
     on:click={containerClick}
     on:keydown={() => {}}
     on:keypress={() => {}}
     on:keyup={() => {}}
     on:mousemove={mouseMove}
     on:scroll={containerScroll}
>
    <div class="dashboard-wrapper"
         style:height="{ rowHeight * rowCount + firstRowHeight}px"
         style:width="{ colWidth * columnCount + firstColumnWidth}px"
    >
        <!-- horizontal lines -->
        <div class="dashboard-line"
             style:height="1px"
             style:left="0px"
             style:top="0px"
             style:width="{colWidth * columnCount + firstColumnWidth }px"></div>
        {#each Array(rowCount + 1) as _, index (index)}
            <div
                class="dashboard-line"
                style:top="{index * rowHeight + firstRowHeight}px"
                style:left="0px"
                style:width="{colWidth * columnCount + firstColumnWidth}px"
                style:height="1px"
            ></div>
        {/each}

        <!-- vertical lines -->
        <div class="dashboard-line" style:height="100%" style:left="0px" style:width="1px"></div>
        {#each Array(columnCount + 1) as _, index (index)}
            <div class="dashboard-line"
                 style:left="{index * colWidth + firstColumnWidth}px"
                 style:width="1px"
                 style:height="100%"></div>
        {/each}

        <!-- left top block-->
        <div class="dashboard-title"
             style:height="{firstRowHeight + 1}px"
             style:left="{scrollX}px"
             style:top="{scrollY}px"
             style:width="{firstColumnWidth + 1}px"
             style:z-index="12"
        ></div>

        <!-- column titles -->
        {#each masters as master, index (index)}
            <div class="dashboard-title"
                 style:left="{index * colWidth + firstColumnWidth}px"
                 style:width="{colWidth + 1}px"
                 style:height="{firstRowHeight + 1}px"
                 style:top="{scrollY}px"
                 style:z-index="10"
            >{ master.name }</div>
        {/each}

        <!-- row titles -->
        {#each generateWorkHours(startWorkDate, endWorkDate) as label, index (index)}
            <div class="dashboard-title"
                 style:top="{index * rowHeight * 4 + firstRowHeight}px"
                 style:left="{scrollX}px"
                 style:width="{firstColumnWidth + 1}px"
                 style:height="{rowHeight * 4 + 1}px"
                 style:z-index="8"
            > { label.format('HH:mm') }
            </div>
        {/each}
        {#if mousePointerX > firstColumnWidth && mousePointerX < firstColumnWidth + columnCount * colWidth &&
        mousePointerY > firstRowHeight && mousePointerY < firstRowHeight + rowHeight * rowCount}
            <div class="selected-item"
                 style:height="{rowHeight - 3}px"
                 style:left="{Math.floor((mousePointerX - firstColumnWidth) / colWidth) * colWidth + firstColumnWidth + 2}px"
                 style:top="{Math.floor((mousePointerY - firstRowHeight) / rowHeight) * rowHeight + firstRowHeight + 2}px"
                 style:width="{colWidth - 3}px"
            >
            </div>
        {/if}

        <!-- items -->
        {#each worksheets as worksheet}
            <DashboardItem worksheet={worksheet}
                           column={master2column(worksheet.master_id)}
                           rowHeight={rowHeight}
                           colWidth={colWidth}
                           firstColumnWidth={firstColumnWidth}
                           firstRowHeight={firstRowHeight}
                           margin={margin}
                           startWorkDate={startWorkDate}
            />
        {/each}

    </div>
</div>

<style>
  .selected-item {
    border-radius: 2px;
    position: absolute;
    background-color: #0dcaf0;
  }

  .dashboard-wrapper {
    position: relative;
    display: block;
  }

  .dashboard-line {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.2);
  }

  .dashboard-title {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border: rgba(0, 0, 0, 0.2) 1px solid;
  }

  .box {
    overflow: auto;
  }

</style>
